// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3S_bj","error":"Textarea_error__2Dhj0","readonly":"Textarea_readonly__1cC1c","disabled":"Textarea_disabled__3bsx6"};